import { render, staticRenderFns } from "./RecordsAndLicensePanel.vue?vue&type=template&id=1a497c56&scoped=true&"
import script from "./RecordsAndLicensePanel.vue?vue&type=script&lang=ts&"
export * from "./RecordsAndLicensePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a497c56",
  null
  
)

export default component.exports